<template>
  <div class="page-result">
    <c-left-side-bar :step="4" />
    <n-loader :loading="$var('load')"></n-loader>
    <c-modal-message :hide.sync="hide" :modal-type="modalType" :state.sync="state"></c-modal-message>
    <div class="mid-container">
      <div class="mid-side">
        <c-mid-head back-route="kln-info" h1="Результаты проведения КЛН" />
        <div class="answers-block">
          <div class="answers-block-head">
            <h2>Вопросы</h2>
            <h3>{{ category.title }}</h3>
          </div>
          <div class="answers-block-body">
            <ul class="answers-list">
              <li v-for="item in questions" v-if="!item.parentId" :key="item.id" class="answers-row">
                <div class="answer">
                  <div v-if="!item.isMemo" class="image-place">
                    <img v-if="checkState(item.id) === 'ignored'" :src="iconIgnored" alt="">
                    <img v-else :src="checkState(item.id) === 'correct' ? iconCorrect : iconIncorrect" alt="">
                  </div>
                  <p class="answer-title" :class="{'memo': item.isMemo}">{{ item.title }}</p>
                </div>
                <div v-for="sub in item.subquestions" class="sub-answers">
                  <div v-if="!sub.isMemo" class="image-place">
                    <img v-if="checkState(sub.id) === 'ignored'" :src="iconIgnored" alt="">
                    <img v-else :src="checkState(sub.id) === 'correct' ? iconCorrect : iconIncorrect" alt="">
                  </div>
                  <p class="answer-title" :class="{'memo': sub.isMemo}">{{ sub.title }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="right-side">
        <div v-if="user.fullName" class="user-info">
          <h3>{{ user.fullName }}</h3>
          <p>Табельный номер: {{ user.personnelNumber }}</p>
        </div>
        <div v-else class="user-info">
          <h3>Гость</h3>
        </div>
        <div class="results">
          <h3>Итоги аттестации</h3>
          <ul>
            <li class="kln-stats">
              <p>Дата проведения клн</p>
              <p>{{ $app.date.format(result.createdAt, 'date') }}</p>
            </li>
            <li class="kln-stats">
              <p>Результат:</p>
              <p>{{ Math.round(result.points) }}%</p>
            </li>
            <li class="kln-stats">
              <p>Общее количество вопросов:</p>
              <p>{{ result.questionsCount }}</p>
            </li>
            <li v-if="result.declineCount > 0" class="kln-stats">
              <p>Количество отклонений:</p>
              <p>{{ result.declineCount }}</p>
            </li>
            <li v-if="result.status === 'finished'" class="kln-stats">
              <p>Награда:</p>
              <p>{{ result.reward || 0 }}</p>
            </li>
          </ul>
        </div>
        <div class="sections">
          <h3>Разделы:</h3>
          <ul class="section-list">
            <li v-for="item in quizzes" :key="item.id" class="section-row" :class="{'active' : isActive(item)}" @click="selectQuiz(item)">
<!--              <div class="icon-place">-->
<!--                <div class="image-place">-->
<!--                  <img :src="item.image" alt="" class="section-img">-->
<!--                </div>-->
<!--              </div>-->
              <div class="section-info">
                <p>{{ category.title }}</p>
                <p>{{ item.title }}</p>
              </div>
            </li>
          </ul>
        </div>

        <div v-if="result?.status === 'declined'" class="accept-buttons">
          <n-button
            flat class="accept"
            @click="remake">
            Править
          </n-button>
        </div>
      </div>
      <div v-if="result?.status === 'unaccepted'" class="accept-buttons">
        <n-button
          flat class="cancel"
          @click="recall">
          Отозвать
        </n-button>
      </div>
    </div>
  </div>
</template>

<script>
import categoryIcon from 'assets/categoryIcon/culture-icon.png'
import iconCorrect from 'assets/icon-correct.svg'
import iconIncorrect from 'assets/icon-incorrect.svg'
import iconIgnored from 'assets/icon-deleted.svg'

export default {
  name: 'PageInfo',
  data() {
    return {
      categoryIcon,
      result: {},
      user: {},
      quizzes: [],
      quiz: {},
      category: {},
      answers: {},
      questions: [],
      isUnAccepted: true,
      modalType: 'accept',
      hide: true,
      state: '',
      iconCorrect,
      iconIgnored,
      iconIncorrect,
    }
  },
  computed: {
    resultId() {
      return this.$route.query.resultId
    },
  },
  watch: {
    state() {
      if (this.state === 'accept') {
        this.accept()
      }
      if (this.state === 'decline') {
        this.decline()
      }
      this.state = ''
    },
  },
  created() {
    this.loadResult()
  },
  methods: {
    loadResult() {
      this.$var('load', true)
      $api.results.get(this.resultId).all().with('answers').then((response) => {
        this.result = response.data.content
        this.isUnAccepted = this.result.status === 'unaccepted'
        if (this.result.userId) {
          this.loadUser()
        }
        this.loadQuizzes()
        this.loadCategory()
        this.getAnswers()
      }).finally(() => {
      })
    },
    loadUser() {
      $api.users.get(this.result.userId).then((response) => {
        this.user = response.data.content
      })
    },
    remake() {
      this.$var('load', true)
      $api.results.remake(this.resultId, { status: 'interrupted', }).then(() => {
        this.$router.push({ name: 'kln-quizzes', query: { categoryId: this.result.categoryId, resultId: this.resultId, }, })
      }).finally(() => {
        this.$var('load', false)
      })
    },
    recall() {
      this.$var('load', true)
      $api.results.remake(this.resultId, { status: 'interrupted', }).then(() => {
        this.$router.push({ name: 'kln-info', })
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadQuizzes() {
      $api.quizzes.get(this.result.categoryId).all().then((response) => {
        this.quizzes = response.data.content
        this.quiz = this.quizzes[0]
        this.loadQuestions()
      })
    },
    loadCategory() {
      $api.categories.get(this.result.categoryId).all().then((response) => {
        this.category = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    getAnswers() {
      $n.map(this.result.answers, (elem) => {
        this.answers = {
          ...this.answers,
          [elem.questionId+'']: {
            value: elem.value,
            ignored: elem.ignored,
          },
        }
      })
    },
    loadQuestions() {
      $api.questions.get(this.quiz.id).all().with('subquestions').then((response) => {
        this.questions = response.data.content
      })
    },
    checkState(questionId) {
      questionId = questionId+''
      if (this.answers[questionId]) {
        return this.answers[questionId].value && !this.answers[questionId].ignored ? 'correct' : this.answers[questionId].ignored ? 'ignored' : 'incorrect'
      } else {
        return 'incorrect'
      }
    },
    selectQuiz(newQuiz) {
      this.quiz = newQuiz
      this.loadQuestions()
    },
    isActive(item) {
      return this.quiz.id === item.id
    },
    accept() {
      $api.results.patch(this.result.id, { status: 'finished', }).then(() => {
        this.$router.push({ name: 'kln-info', })
      })
    },
    decline() {
      $api.results.patch(this.result.id, { status: 'declined', }).then(() => {
        this.$router.push({ name: 'kln-info', })
      })
    },
    cancel() {
      this.$router.push({ name: 'kln-info', })
    },
    showModal(modalType) {
      this.modalType = modalType
      this.hide = false
    },
  },
}
</script>

<style lang="scss" scoped>
.page-result {
  display: flex;
  min-height: 100vh;

  .mid-container {
    padding: 40px 20px 0 20px;
    width: 100%;
    position: relative;

    .mid-side {
      .answers-block {
        .answers-block-head {
          h2 {
            color: var(--secondary);
            font-size: 2em;
            font-weight: bold;
            margin: 22px 0 0 0;
            padding: 0;
          }
          h3 {
            margin: 8px 0 0 0;
            padding: 0;
            color: #969FA8;
            font-size: 1.2em;
          }
        }
        .answers-block-body {
          margin: 22px 0 0 0;
          overflow: auto;
          .answers-list {
            list-style: none;
            padding: 0;

            .answers-row {

              .answer-title {
                flex: 2;
              }
              max-width: 440px;
              .answer {
                display: flex;
                align-items: center;
                margin-bottom: 28px;
                position: relative;
                .image-place {
                  width: 20px;
                  height: 20px;
                  margin-right: 15px;
                  flex-shrink: 0;
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }

                &:before {
                  position: absolute;
                  content: '';
                  width: 70%;
                  height: 1px;
                  background-color: #E9E9EC;
                  left: 35px;
                  bottom: -15px;
                }

                .answer-state {
                  position: relative;
                  width: 20px;
                  height: 20px;
                  background-color: var(--primary);
                  color: var(--primary);
                  border-radius: 4px;
                  margin-right: 15px;
                  &.correct {
                    &::before {
                      position: absolute;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      content: '\2713';
                      font-size: 1.0em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      top: 0;
                    }
                  }
                  &.ignored {
                    background-color: #DB0007;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '\00D7';
                      font-size: 1.6em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: 0;
                      bottom: 0;
                    }
                  }
                  &.incorrect {
                    background-color: #E2E4EC;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '-';
                      font-size: 2.2em;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: -5px;
                      bottom: 0;
                    }
                  }
                }
              }
              .sub-answers {
                display: flex;
                align-items: center;
                padding: 10px 35px;
                margin-bottom: 28px;
                position: relative;
                .image-place {
                  width: 20px;
                  height: 20px;
                  margin-right: 15px;
                  flex-shrink: 0;
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }

                &:before {
                  position: absolute;
                  content: '';
                  width: 70%;
                  height: 1px;
                  background-color: #E9E9EC;
                  left: 35px;
                  bottom: -15px;
                }

                .answer-state {
                  position: relative;
                  width: 20px;
                  height: 20px;
                  background-color: var(--primary);
                  color: var(--primary);
                  border-radius: 4px;
                  margin-right: 15px;
                  &.correct {
                    &::before {
                      position: absolute;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      content: '\2713';
                      font-size: 1.0em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      top: 0;
                    }
                  }
                  &.ignored {
                    background-color: #DB0007;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '\00D7';
                      font-size: 1.6em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: 0;
                      bottom: 0;
                    }
                  }
                  &.incorrect {
                    background-color: #E2E4EC;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '-';
                      font-size: 2.2em;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: -5px;
                      bottom: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .right-container {
    padding: 40px 20px 0 20px;
    background-color: #FCFCFC;
    position: relative;
    min-width: 460px;
    .accept-buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 29px;

      .accept{
        color: var(--secondary);
        font-size: 1.1em;
        width: 190px;
        height: 50px;
        margin-right: 10px;
        background-color: #F2F3F7;
        border-radius: 8px;
      }

      .cancel{
         color: #ffffff !important;
        font-size: 1.1em;
        width: 190px;
        height: 50px;
        margin-right: 10px;
        background-color: #ff4242;
        border-radius: 8px;
      }
    }
    .right-side {
      position: relative;
      height: 90%;


      .user-info {
        margin-bottom: 28px;
        h3 {
          font-size: 1.05em;
          color: var(--secondary)
        }
        p {
          color: #6D6F7B;
          font-size: 0.8em;
        }
      }

      .results {
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        h3 {
          font-size: 1.5em;
          color: var(--secondary);
          font-weight: bold;
          margin-bottom: 11px;
        }
        .kln-stats {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 40px;
          p {
            color: var(--secondary);
            font-size: 1.05em;
            &:first-child {
              &::before {
                content: '';
                height: 1px;
                width: 390px;
                position: absolute;
                background-color: #E9E9EC;
                left: 0;
                bottom: -19px;
              }
            }
          }
        }
      }

      .sections {
        margin-top: 24px;
        h3 {
          font-size: 1.05em;
          color: #000000;
          font-weight: bold;
          margin-bottom: 28px;
        }
        .section-list {
          list-style: none;
          padding: 0;
          margin: 0;
          overflow: auto;
          height: calc(100vh/3);
          .section-row {
            cursor: pointer;
            display: flex;
            margin-bottom: 25px;
            border-radius: 12px;
            height: 66px;
            align-items: center;
            &.active {
              background-color: rgba(38, 79, 54, 0.2);
            }
            .icon-place {
              width: 64px;
              height: 64px;
              background-color: #F6F6F6;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 12px;
              .image-place {
                width: 44px;
                height: 44px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  aspect-ratio: auto;
                }
              }
            }
            .section-info {
              margin-left: 20px;
              p{
                font-size: 1.1em;
                color: var(--secondary);
                &:first-child{
                  color: #626C77;
                  font-size: 0.9em;
                }
              }
            }
          }
        }
      }

      .accept-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 29px;

        .accept{
          color: var(--secondary);
          font-size: 1.1em;
          width: 190px;
          height: 50px;
          margin-right: 10px;
          background-color: #F2F3F7;
          border-radius: 8px;
        }

        .cancel{
          color: #DB0007;
          font-size: 1.1em;
          width: 190px;
          height: 50px;
          background-color: #F2F3F7;
          border-radius: 8px;
        }
      }
    }
  }
  .memo {
    font-style: italic;
  }
  h3 {
    margin: 0;
    padding: 0;
  }
  p {
    margin: 0;
    padding: 0;
  }
}
</style>
